/**
 * 二次封装axios
 */
import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: ''
})

service.interceptors.response.use(response => {
  if (response.data && response.data.code && response.data.code !== '0') {
    const error = response.data.message || '数据接口异常'
    Message({ type: 'warn', message: error })

    return Promise.reject(error)
  }
  return response
}, error => {
  const status = error.response && error.response.status
  if(status != 400){
    Message({ type: 'warn', message: '接口异常' })
  }
  return Promise.reject(error.response)
})

export default service
